// extracted by mini-css-extract-plugin
export var box = "hamburgers-module--box--8ae9b";
export var hamburger = "hamburgers-module--hamburger--9f08d";
export var hamburgerSpin = "hamburgers-module--hamburgerSpin--14bc3";
export var inner = "hamburgers-module--inner--797c1";
export var isActive = "hamburgers-module--isActive--4c76a";